

<!-- @for (banner of banners; track banner) {
  <div class="homepage_prodHeader" [innerHTML]="banner.urlLink"></div>
  <div class="homepage_prodsubHeader" [innerHTML]="banner.paragraphcontent"></div>
  <div class="col-xs-12 home_prodSectionUK" id="home_prodSection">
    <div class="col-xs-12 col-md-12 home_prodCol" >
      <div class="col-xs-12 prod_content" >
        <div class="col-xs-12 home_prodimg" id="home_prodimg1" alt="aQIV Product Logo" style="background-image: url('{{getMediaUrl(banner.media)}}');"></div>
        <div class="col-xs-12 home_prodheader no-pad" id="">{{banner.h2content}}</div>
        <div class="col-xs-12 home_prodcontent no-pad" [innerHTML]="banner.content"></div>
      </div>
      <div class="col-xs-12" id="home_learnmorebtn">
        <a [href]="banner.urlLink" appRouterlinkinterceptor>{{ banner.paragraphcontent }}</a>
      </div>
    </div>
  </div>
} -->

<!-- Section Header -->


<!-- 3-Column Product Cards Grid -->


@if (banners && banners.length > 0) {
  <div class="home_prodSectionUK" id="home_prodSection">
    <div class="homepage_prodCardContaner">
      @for (banner of banners; track banner) {
        <div class="home_prodCard">
          <div class="home_prodImgWrap">
            <div class="col-xs-12 home_prodimg" id="home_prodimg1" alt="aQIV Product Logo" style="background-image: url('{{getMediaUrl(banner.media)}}');"></div>
          </div>
          <div class="home_prodheader" [innerHTML]="banner.h2content"></div>
          <div class="home_prodcontent" [innerHTML]="banner.content"></div>
        </div>
      }
    </div>

  </div>
}